<template>
    <configured-layout
        title="Select Color"
        :breadcrumbs="breadcrumbs"
        :next-title="nextTitle"
        @next="onNext"
    >
        <options-list :options="uniqColorOptions" :required="true" />
    </configured-layout>
</template>

<script>
import _ from "lodash";
import { get } from "vuex-pathify";
import ConfiguredLayout from "./components/Layout";
import OptionsList from "Modules/Configure/components/OptionsList";
import loader from "Modules/Configure/mixins/loader";

export default {
    components: {
        OptionsList,
        "configured-layout": ConfiguredLayout
    },

    mixins: [loader],

    props: {
        styleId: {
            required: true,
            type: String
        }
    },

    computed: {
        uniqColorOptions: get("configure/uniqColorOptions"),
        headerItems: get("configure/headerItems"),
        powertrainOptions: get("configure/powertrainOptions"),
        breadcrumbs() {
            const breadcrumbs = [
                {
                    text: this.vehicleName,
                    href: this.vehicleDetailsUrl
                }
            ];

            if (_.size(this.powertrainOptions) > 0) {
                breadcrumbs.push({
                    text: "Select Powertrain",
                    to: { name: "powertrain" }
                });
            }

            breadcrumbs.push({
                text: "Select Color",
                active: true
            });

            return breadcrumbs;
        },
        nextTitle() {
            const headerLabels = _.keys(this.headerItems);
            if (_.size(headerLabels) === 0) {
                return "Next Step";
            }

            return `Next Step | ${headerLabels[0]}`;
        }
    },

    methods: {
        onNext() {
            this.$router.push({ name: "options" });
        }
    }
};
</script>
